import { useState } from "react";
import { FileUpload } from "../FileUpload";
import { Button } from "../ui/button";
import { authApi, formatApiErrorDetail } from "../../lib/authApi";

export const SourceReplacement = ({ data, onUpdated, disabled }) => {
  const [files, setFiles] = useState([]), [saving, setSaving] = useState(false), [error, setError] = useState("");
  const replace = async () => {
    setSaving(true); setError("");
    try {
      const result = await authApi.patch(`/rfqs/${data.rfq_id}/understanding/sources`, { revision: data.analysis.revision, file_ids: files.map(f => f.id) });
      setFiles([]); onUpdated(result.data);
    } catch (err) { setError(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setSaving(false); }
  };
  return <details className="border-t border-border pt-5 mt-8" data-testid="s4-source-replacement"><summary className="cursor-pointer text-sm text-primary" data-testid="s4-replace-sources-toggle">Replace source documents</summary>
    <div className="space-y-4 mt-4 max-w-3xl"><p className="text-xs text-muted-foreground" data-testid="s4-replace-warning">Replacing sources invalidates extraction, customer confirmation and engineering approval. Previous source references remain in the audit record.</p>
      <FileUpload files={files} onChange={setFiles} testId="s4-replacement-upload" maxFiles={3} />
      {error && <p className="text-sm text-destructive" role="alert" data-testid="s4-replacement-error">{error}</p>}
      <Button variant="outline" disabled={disabled || saving || !files.length} onClick={replace} data-testid="s4-replace-sources-btn">{saving ? "Replacing..." : "Replace and reset review"}</Button>
    </div>
  </details>;
};